import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { TelemetryService } from '../../../services/telemetry/telemetry.service';
import {
  TrackProcessAbandon,
  TrackProcessComplete,
  TrackProcessError,
  TrackProcessStart,
  TrackProcessStep,
} from '../../actions/adobe-launch/adobe-launch.actions';

/** Emits a journey span for each TrackProcess* action. */
@Injectable()
export class TelemetryEffects {
  constructor(
    private actions$: Actions,
    private telemetryService: TelemetryService,
  ) {}

  journeyStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TrackProcessStart),
        tap((action) =>
          this.telemetryService.recordJourneyEvent('coo.journey.start', {
            processType: action.processType,
            accountType: action.accountType,
          }),
        ),
      ),
    { dispatch: false },
  );

  journeyStep$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TrackProcessStep),
        tap((action) =>
          this.telemetryService.recordJourneyEvent('coo.journey.step', {
            processType: action.processType,
            processStep: action.processStep,
            accountType: action.accountType,
          }),
        ),
      ),
    { dispatch: false },
  );

  journeyComplete$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TrackProcessComplete),
        tap((action) =>
          this.telemetryService.recordJourneyEvent('coo.journey.complete', {
            processType: action.processType,
            transactionId: action.transactionId,
            accountType: action.accountType,
          }),
        ),
      ),
    { dispatch: false },
  );

  journeyError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TrackProcessError),
        tap((action) =>
          this.telemetryService.recordJourneyEvent(
            'coo.journey.error',
            {
              errorCode: action.errorCode,
              processStep: action.processStep,
            },
            true,
          ),
        ),
      ),
    { dispatch: false },
  );

  journeyAbandon$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TrackProcessAbandon),
        tap((action) =>
          this.telemetryService.recordJourneyEvent('coo.journey.abandon', {
            processType: action.processType,
            processStep: action.processStep,
          }),
        ),
      ),
    { dispatch: false },
  );
}
